import ErrorIcon from '@/fsd/shared/ui/icons/Error';
import SuccessIcon from '@/fsd/shared/ui/icons/Success';
import WaitIcon from '@/fsd/shared/ui/icons/Wait';
import { NotificationType } from '../../model/types/NotificationType';

export const getIconByType = (type: NotificationType) => {
  switch (type) {
    case 'success':
      return <SuccessIcon />;
    case 'danger':
      return <ErrorIcon />;
    case 'info':
      return <WaitIcon />;
    default:
      return null;
  }
};
